import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { useRouteContext, useSearchContext } from '../../context';
import { useLocation } from '../../hooks/queries/location';
import { generateSearchUrl } from '../../utils';
import './CategoryBrowseViewMore.scss';

interface CategoryBrowseViewMoreProps {
    queryOverload?: OrganicEventSearchFiltersApiPayload;
    title?: string | GenericLazyString;
}

const handleClick = (title?: string) => {
    trackAnalyticsEvent({
        category: 'category-page',
        action: 'ViewMore',
        label: title,
    });
};

export const CategoryBrowseViewMore: React.FunctionComponent<
    CategoryBrowseViewMoreProps
> = (props) => {
    //TODO: support server rendering for this bit
    const routeInfo = useRouteContext();
    const activeTag = routeInfo?.parsedValues?.activeTag;
    const { data: location } = useLocation();
    const { query } = useSearchContext();

    if (
        !location ||
        (activeTag && activeTag.includes('EventbriteSubCategory'))
    ) {
        return props.children ? <>{props.children}</> : null;
    }

    const currentQuery = {
        ...query,
        places: location?.placeId ? [location?.placeId] : undefined,
        online_events_only: location?.isOnline,
        ...(props?.queryOverload || {}),
    };

    const path = generateSearchUrl(currentQuery, location);

    return (
        <a
            href={path}
            onClick={() => handleClick(props?.title?.toString())}
            className="category-browse-view-more__link eds-text-color--ui-blue--hover"
        >
            {props.children ? props.children : gettext('View more')}
        </a>
    );
};
